import React, { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';

const AdvisoryInquiry = ({ open, onOpenChange, subject, ro }) => {
  const [status, setStatus] = useState('idle');
  const submit = async (event) => {
    event.preventDefault();
    if (status === 'loading') return;
    const form = event.currentTarget;
    const data = new FormData(form);
    setStatus('loading');
    try {
      const response = await axios.post('/api/contact', {
        name: data.get('name'), email: data.get('email'),
        message: `${subject}\n\n${data.get('message')}`,
      });
      if (!response.data?.id) throw new Error('Inquiry not confirmed');
      form.reset(); setStatus('success');
    } catch { setStatus('error'); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100%-2rem)] max-h-[90svh] overflow-y-auto bg-bone text-charcoal p-8 sm:rounded-none">
        <DialogTitle className="text-2xl leading-tight">{subject}</DialogTitle>
        <DialogDescription>{ro ? 'Spune-ne despre proiectul tău și te vom contacta.' : 'Tell us about your project and we will get in touch.'}</DialogDescription>
        {status === 'success' ? <p role="status">{ro ? 'Mulțumim! Cererea ta a fost trimisă.' : 'Thank you! Your inquiry has been sent.'}</p> : (
          <form onSubmit={submit} className="space-y-5" data-testid="advisory-inquiry-form">
            <label className="block text-sm">{ro ? 'Nume / Companie' : 'Name / Company'}<input name="name" required maxLength={120} autoComplete="name" className="block mt-2 w-full border-b border-charcoal/40 bg-transparent py-2" /></label>
            <label className="block text-sm">Email<input name="email" type="email" required maxLength={254} autoComplete="email" className="block mt-2 w-full border-b border-charcoal/40 bg-transparent py-2" /></label>
            <label className="block text-sm">{ro ? 'Despre spațiul sau proiectul tău' : 'About your space or project'}<textarea name="message" required maxLength={3500} rows={5} className="block mt-2 w-full border-b border-charcoal/40 bg-transparent py-2" /></label>
            {status === 'error' && <p role="alert" className="text-sm">{ro ? 'Mesajul nu a putut fi trimis. Te rugăm să încerci din nou.' : 'Your message could not be sent. Please try again.'}</p>}
            <button type="submit" disabled={status === 'loading'} className="bg-charcoal text-bone px-6 py-3 disabled:opacity-50">{status === 'loading' ? (ro ? 'Se trimite…' : 'Sending…') : (ro ? 'Trimite cererea' : 'Send inquiry')}</button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
export default AdvisoryInquiry;
